export interface Experience {
    id: string;
    company: string;
    role: string;
    period: string;
    duration: string;
    location: string;
    description: string;
    achievements: string[];
    skills: string[];
    current: boolean;
    createdAt?: number | string;
}

export type ExperienceCreate = Omit<Experience, 'id' | 'createdAt'>;

const API_URL = '/api/experiences';

export async function getExperiences(): Promise<Experience[]> {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error('Erreur lors du chargement des expériences');
    return res.json();
}

export async function createExperience(data: ExperienceCreate): Promise<Experience> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la création');
    return res.json();
}

export async function updateExperience(id: string, data: Partial<ExperienceCreate>): Promise<Experience> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la modification');
    return res.json();
}

export async function deleteExperience(id: string): Promise<void> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!res.ok) throw new Error('Erreur lors de la suppression');
}
